export default "__VITE_ASSET__CnZR8m7S__"